/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AssetManagementListResponse } from '../../models/asset-management-list-response';
import { BaseResponse } from '../../models/base-response';

export interface AssetManagementControllerC$Params {
  agreement_id: number;

/**
 * Sends 0 to remove limit
 */
  limit: number;
  skip: number;
  asset_has_end_of_warranty_date?: boolean;
}

export function assetManagementControllerC(http: HttpClient, rootUrl: string, params: AssetManagementControllerC$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: AssetManagementListResponse;
}>> {
  const rb = new RequestBuilder(rootUrl, assetManagementControllerC.PATH, 'get');
  if (params) {
    rb.path('agreement_id', params.agreement_id, {});
    rb.query('limit', params.limit, {});
    rb.query('skip', params.skip, {});
    rb.query('asset_has_end_of_warranty_date', params.asset_has_end_of_warranty_date, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: AssetManagementListResponse;
      }>;
    })
  );
}

assetManagementControllerC.PATH = '/asset-management/{agreement_id}/agreement-assets';
